import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";

export interface AuthenState {
  user: string;
  shantenCd: string;
  shantenNm: string;
  timerRefeshToken: any;
  token: string;
}

const initialState: AuthenState = {
  user: "",
  shantenCd: "",
  shantenNm: "",
  token: "",
  timerRefeshToken: null
};

const actions: ActionTree<AuthenState, any> = {
  setUser({ commit }: ActionContext<AuthenState, any>, payload: string): void {
    commit("setUser", payload);
  },
  setToken({ commit }: ActionContext<AuthenState, any>, payload: string): void {
    commit("setToken", payload);
  },
  setTimerRefeshToken(
    { commit }: ActionContext<AuthenState, any>,
    payload: any
  ): void {
    commit("setTimerRefeshToken", payload);
  },
  clearTimerRefeshToken(
    { commit }: ActionContext<AuthenState, any>,
    payload: any
  ): void {
    commit("clearTimerRefeshToken", payload);
  },
  clearState({ commit }: ActionContext<AuthenState, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setTimerRefeshToken(state: AuthenState, payload: any) {
    Object.assign(state, { timerRefeshToken: payload });
  },
  clearTimerRefeshToken(state: AuthenState) {
    if (state.timerRefeshToken) {
      clearInterval(state.timerRefeshToken);
    }
    Object.assign(state, { timerRefeshToken: null });
  },
  setUser(state: AuthenState, payload: string) {
    state.user = payload;
  },
  setToken(state: AuthenState, payload: string) {
    state.token = payload;
  },
  clearState(state: AuthenState) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<AuthenState, any> = {
  timerRefeshToken(state: AuthenState): any {
    return state.timerRefeshToken;
  },
  user(state: AuthenState): string {
    return state.user;
  },
  token(state: AuthenState): string {
    return state.token;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: {...initialState},
  getters,
  actions,
  mutations
};
